/**
 * What a bookmark control says on hover.
 *
 * The icon alone does not say that the control builds the "My schedule"
 * filter, and the three disabled cases are worse: each one leaves a button
 * that does nothing, and they have different answers. The order is by how
 * long the person has to wait: until the list arrives, then until the write
 * lands. Sessions with no time never reach a bookmark control.
 *
 * The string is carried by the wrapper element rather than the button,
 * because a disabled button receives no pointer events and its own title
 * never opens.
 */
export function bookmarkTitle({
  bookmarked,
  ready,
  pending,
}: {
  bookmarked: boolean;
  ready: boolean;
  pending: boolean;
}): string {
  if (!ready) return "My schedule is still loading";
  if (pending) return "Saving your last change";
  return bookmarked ? "Remove from my schedule" : "Add to my schedule";
}
